// Palette + botanical shapes for each Deux Rituels bath salt scent.
// The salt is the landscape — restrained composition per scent.

export const BATH_SALT_SCENTS = {
  encens: {
    label: "Encens",
    notes: ["Smoked Frankincense", "Amber", "Labdanum"],
    feeling: "Grounding · Centering · Sacred",
    subtitle: "A desert landscape.",
    vessel: "#3A2530",
    accent: "#c9a67a",
    // predominantly ivory, dramatic black + amber accents
    palette: ["#EDE6D8", "#DCCFB7", "#141212", "#8a5a2c", "#3c1f0d"],
    botanicals: [],
  },
  cachemire: {
    label: "Cachemire",
    notes: ["Rose", "Lavender", "White Sandalwood"],
    feeling: "Comfort · Softness · Restoration",
    subtitle: "Luxurious linen and softness.",
    vessel: "#6d5a5f",
    accent: "#e6ddcf",
    // mostly ivory with pink Himalayan + subtle muted plum
    palette: ["#EDE6D8", "#e6d4cc", "#c7a0a3", "#8e7d95"],
    botanicals: ["#7a3a4a", "#5c4a68"],  // rose petals + lavender buds
  },
  eucalyptus: {
    label: "Eucalyptus",
    notes: ["Eucalyptus", "Peppermint", "Spearmint"],
    feeling: "Renewal · Clarity · Freshness",
    subtitle: "A luxury spa experience.",
    vessel: "#4a5a4f",
    accent: "#dbe4d5",
    // predominantly white with restrained green
    palette: ["#EDE6D8", "#e0e8dc", "#8fa38a"],
    botanicals: ["#5b7458", "#7c9375"],
  },
  sauge: {
    label: "Sauge",
    notes: ["White Sage", "Cedar", "Rosemary"],
    feeling: "Purification · Balance · Earth",
    subtitle: "A forest after rainfall.",
    vessel: "#6a6560",
    accent: "#e0dbd0",
    // stone + ivory with scattered sage / cedar
    palette: ["#dcd5c7", "#b8afa2", "#EDE6D8", "#7a7568"],
    botanicals: ["#6f7a5c", "#4a5238", "#3f2a18"],
  },
  lavande: {
    label: "Lavande",
    notes: ["Lavender", "Chamomile", "Vanilla Bean"],
    feeling: "Calm · Sleep · Peace",
    subtitle: "A peaceful evening ritual.",
    vessel: "#cdbfb0",
    accent: "#3a2530",
    // mostly ivory with delicate lavender + chamomile
    palette: ["#EDE6D8", "#e8e0d1", "#c7bcc9"],
    botanicals: ["#6a4c78", "#dfc98a", "#3a2a12"],
  },
};

export const BATH_SALT_SCENT_ORDER = ["encens", "cachemire", "eucalyptus", "sauge", "lavande"];
